import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {CreateNotificationWrapper} from './create-totification/create-notification';
import {EditNotificationWrapper} from './edit-totification/edit-notification';
import {InternalNotificationList} from './notification-list/internal-notification-list';
import {UserNotifications} from './user-notifications/user-notifications';

export const InternalNotificationRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<InternalNotificationList/>}/>
            <Route path="/builder" element={<CreateNotificationWrapper/>}/>
            <Route path="/:notificationId" element={<EditNotificationWrapper/>}/>
            <Route path="/my-notifications/:notificationId?" element={<UserNotifications/>}/>

            <Route path="*" element={<Navigate to="/internal-notification"/>}/>
        </Routes>
    );
};
